/* eslint-disable */
import router from 'src/router'
import {
  SET_CURRENT_MODAL,
  SET_MODAL_DATA
} from './mutation-types'

const state = {
  currentModal: '',
  modalData: {},
}

const mutations = {
  [SET_CURRENT_MODAL](state, payload) {
    state.currentModal = payload
  },
  [SET_MODAL_DATA](state, payload) {
    state.modalData = payload
  }
}

const actions = {
  showModal({ commit }, payload) {
    commit(SET_CURRENT_MODAL, payload)
    let path = router.currentRoute.path
    if (path[path.length - 1] !== '/') {
      path += '/'
    }
    const title = payload[0].toUpperCase() + payload.slice(1) + ' modal shown'
    this._vm.$ga.page({
      page: path + payload,
      title,
    })
    this._vm.$gtag.pageview({
      "page_title": title,
      "page_location": path + payload,
    })
  },
  setModalData({ commit }, payload) {
    commit(SET_MODAL_DATA, payload)
  },
  hideModal({ commit }) {
    commit(SET_CURRENT_MODAL, '')
    commit(SET_MODAL_DATA, {})
  }
}

const getters = {
  modalData: state => state.modalData,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
